export const FETCH_DOMAIN_GROUPS_REQUEST = 'FETCH_DOMAIN_GROUPS_REQUEST';
export const FETCH_DOMAIN_GROUPS_SUCCESS = 'FETCH_DOMAIN_GROUPS_SUCCESS';
export const FETCH_DOMAIN_GROUPS_FAILURE = 'FETCH_DOMAIN_GROUPS_FAILURE';

export const SAVE_DOMAIN_GROUP_REQUEST = 'SAVE_DOMAIN_GROUP_REQUEST';
export const SAVE_DOMAIN_GROUP_SUCCESS = 'SAVE_DOMAIN_GROUP_SUCCESS';
export const SAVE_DOMAIN_GROUP_FAILURE = 'SAVE_DOMAIN_GROUP_FAILURE';

export const DELETE_DOMAIN_GROUP_REQUEST = 'DELETE_DOMAIN_GROUP_REQUEST';
export const DELETE_DOMAIN_GROUP_SUCCESS = 'DELETE_DOMAIN_GROUP_SUCCESS';
export const DELETE_DOMAIN_GROUP_ERROR = 'DELETE_DOMAIN_GROUP_ERROR';

export const DELETE_GROUPS_FROM_DOMAINS_REQUEST = 'DELETE_GROUPS_FROM_DOMAINS_REQUEST';
export const DELETE_GROUPS_FROM_DOMAINS_SUCCESS = 'DELETE_GROUPS_FROM_DOMAINS_SUCCESS';
export const DELETE_GROUPS_FROM_DOMAINS_FAILURE = 'DELETE_GROUPS_FROM_DOMAINS_FAILURE';


// ----------------------------------------------------------------------------
// Action Types for domain grouping form state
// ----------------------------------------------------------------------------
export const CREATE_DOMAIN_GROUP = 'CREATE_DOMAIN_GROUP';
export const SELECT_DOMAIN_GROUP = 'SELECT_DOMAIN_GROUP';
export const RENAME_SELECTED_DOMAIN_GROUP = 'RENAME_SELECTED_DOMAIN_GROUP';
export const UPDATE_DOMAINS_IN_SELECTED_GROUP = 'UPDATE_DOMAINS_IN_SELECTED_GROUP';
export const DISMISS_DOMAIN_GROUPING_FORM = 'DISMISS_DOMAIN_GROUPING_FORM';
